<template>
    <div>
        <vs-row class="pt-3 pb-3">
            <vs-col v-for="(info, index) in infoCobros" v-bind:key="index" class="widthCard">
                <md-card class="text-center" :class="info.color" md-with-hover>
                    <md-ripple>
                        <md-card-header>
                        <div class="md-title">{{info.total | currency}}</div>
                        <div class="md-subhead">{{info.title}}</div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
            <!-- <vs-col v-for="(info, index) in saldoFavor" v-bind:key="index" class="widthCard">
                <md-card class="text-center" :class="info.color" md-with-hover>
                    <md-ripple>
                        <md-card-header>
                        <div class="md-title">{{info.total | currency}}</div>
                        <div class="md-subhead">{{info.title}}</div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col> -->
        </vs-row>
    </div>
</template>

<script>

import cobranza from '../../../api/requests/cobranza-persona.js'
export default {
    props:[
        'personaId',
        'cicloEscolar',
        'institucion'
    ],
    data () {
        return {
            infoCobros: this.getCobros(),
            saldoFavor: this.getSaldo()
        }
    },
    methods: {
        getCobros(datos) {
            if(datos){
                const info = {
                    "porCobrar": datos.por_cobrar,
                    "carteraVencida": datos.cartera_vencida,
                    "descuentos_becas": datos.descuentos_becas
                }
                const result = []
                if (info.porCobrar) {
                    const obj = {
                        "title": 'Cargos por cobrar en tiempo',
                        "total": info.porCobrar,
                        "color": 'md-warn'
                    }
                    result.push(obj)
                }
                if (info.carteraVencida) {
                    const obj = {
                        "title": 'Cartera vencida',
                        "total": info.carteraVencida,
                        "color": 'md-danger'
                    }
                    result.push(obj)
                }
                if (info.descuentos_becas) {
                    const obj = {
                        "title": 'Descuentos por Beca',
                        "total": info.descuentos_becas,
                        "color": 'md-dark'
                    }
                    result.push(obj)
                }
                return result
            }
        } ,
        getSaldo(datos) {
            if(datos){
                const info = {
                    "saldo_a_favor": datos.saldo_a_favor
                }
                const result = []
                if (info.saldo_a_favor) {
                    const obj = {
                        "title": 'Saldo a favor',
                        "total": info.saldo_a_favor,
                        "color": 'md-success'
                    }
                    result.push(obj)
                }
                return result
            }
        } ,
        async getEstadisticasCargos(){
            try {
                let params = {
                    id : this.personaId,
                    ciclo_escolar: this.cicloEscolar,
                    institucion: this.institucion
                }
                const response = await cobranza.getInfoEstadisticasCargo(params)
                this.infoCobros = this.getCobros(response.data)
                // if (response.data instanceof Object){
                //     this.dataEstadisticosGral = response.data  
                // }

            } catch (error) {
                
            }
        },
    }
}
</script>

<style scoped>
.md-warn{
    background: #ffbc34;
    color: white;
    border-radius: 7px;
}

.widthCard{
    width: 30%;
    margin: 0 1.5%;
    @media only screen and (max-width: 768px) {
        width: 47%;
        margin: 1.5%;
    }
}

.md-danger{
    background: #f62d51;
    color: white;
    border-radius: 7px;
}

.md-dark{
    background: #19191a;
    color: white;
    border-radius: 7px;
}
</style>